var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "credit-card (1) 1",
    clipPath: "url(#clip0_1111_35342)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.9584 3.83984H1.83844C1.04452 3.83984 0.398438 4.48592 0.398438 5.27984V18.7198C0.398438 19.5138 1.04452 20.1598 1.83844 20.1598H22.9584C23.7524 20.1598 24.3984 19.5138 24.3984 18.7198V5.27984C24.3984 4.48592 23.7524 3.83984 22.9584 3.83984ZM23.4384 18.7198C23.4384 18.9838 23.2224 19.1998 22.9584 19.1998H1.83844C1.5735 19.1998 1.35844 18.9838 1.35844 18.7198V5.27984C1.35844 5.01486 1.5735 4.79984 1.83844 4.79984H22.9584C23.2224 4.79984 23.4384 5.01486 23.4384 5.27984V18.7198Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M23.9189 8.16016H0.878906V10.0802H23.9189V8.16016Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.9184 7.67969H0.878437C0.6135 7.67969 0.398438 7.8947 0.398438 8.15969V10.0797C0.398438 10.3447 0.6135 10.5597 0.878437 10.5597H23.9184C24.1834 10.5597 24.3984 10.3447 24.3984 10.0797V8.15969C24.3984 7.8947 24.1834 7.67969 23.9184 7.67969ZM23.4384 9.59969H1.35844V8.63969H23.4384V9.59969Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.3583 13.4395H4.71828C4.45334 13.4395 4.23828 13.6545 4.23828 13.9195C4.23828 14.1844 4.45334 14.3995 4.71828 14.3995H13.3583C13.6232 14.3995 13.8383 14.1844 13.8383 13.9195C13.8383 13.6545 13.6232 13.4395 13.3583 13.4395Z",
    fill: "black"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M9.51828 15.3594H4.71828C4.45334 15.3594 4.23828 15.5744 4.23828 15.8394C4.23828 16.1043 4.45334 16.3194 4.71828 16.3194H9.51828C9.78322 16.3194 9.99828 16.1043 9.99828 15.8394C9.99828 15.5744 9.78322 15.3594 9.51828 15.3594Z",
    fill: "black"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1111_35342"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.398438)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard);
export default __webpack_public_path__ + "static/media/creditCard.0e8bcf29b95301d96e5ecfdd060df55c.svg";
export { ForwardRef as ReactComponent };